import { Component, Input, TemplateRef, ViewChild } from '@angular/core';
import { FormatConfigService } from '../../../core/services/format-config.service';
import { NgTemplateOutlet, PlatformLocation } from '@angular/common';
import { ComponentLocationStrategy } from '../../services/location-strategy/component-location-strategy';
import { KompaktdarstellungTemplateComponent } from '../kompakt-darstellung-template.component';
import {
  DateEntryMeta,
  PersonGbListEntryMeta,
  PersonGbMasterId,
  PersonGbVersionDetailEntryMeta,
  PersonGbVersionId
} from '../../../core/gb-api';
import { keysToTranslate } from 'i18n/keys-to-translate';
import { LinkComponent } from '../../components/link/link.component';
import { TranslatePipe } from '@ngx-translate/core';
import { DayMonthYearDatePipe } from '../../pipes/simple/dayMonthYearDate.pipe';
import { FormatUidPipe } from '../../pipes/format/format-uid.pipe';
import { PermissionResponse } from '../../../core/base-api';
import { AppPermissionService } from '../../../core/services/app-permission.service';
import { PersonStammMasterDetailEntryMeta } from '../../../core/personstamm-api';
import { NgbTooltip } from '@ng-bootstrap/ng-bootstrap';
import PermissionsEnum = PermissionResponse.PermissionsEnum;

@Component({
  selector: 'cap-kompakt-persongb',
  templateUrl: './kompakt-persongb.component.html',
  styleUrls: ['./kompakt-persongb.component.scss'],
  imports: [LinkComponent, NgTemplateOutlet, TranslatePipe, DayMonthYearDatePipe, FormatUidPipe, NgbTooltip]
})
export class KompaktPersongbComponent extends KompaktdarstellungTemplateComponent {
  @Input() item: PersonGbListEntryMeta | PersonGbVersionDetailEntryMeta;

  @Input() enableNavigation = true;
  hasPermissionAuskunft: boolean;
  hasAuskunftsperre: boolean;
  @Input() itemMasterId: PersonGbMasterId;
  @Input() isEigentuemer = false;
  @ViewChild('typ00', { static: true })
  typ00Template: TemplateRef<any>;
  @ViewChild('typ01', { static: true })
  typ01Template: TemplateRef<any>;

  constructor(
    protected formatService: FormatConfigService,
    protected location: PlatformLocation,
    protected componentLocation: ComponentLocationStrategy,
    private appPersmissionService: AppPermissionService
  ) {
    super(formatService, 'PERSONGB', location, componentLocation);
    keysToTranslate(['EINFACHEGESELLSCHAFT', 'GUETERGEMEINSCHAFT', 'GEMEINDERSCHAFT', 'ERBENGEMEINSCHAFT']);
    this.hasPermissionAuskunft = this.appPersmissionService.hasPermission(PermissionsEnum.AUSKUNFTSPERRE);
  }

  @Input()
  set auskunftsperre(auskunftsperre: PersonStammMasterDetailEntryMeta.AuskunftsperreEnum) {
    if (!auskunftsperre) {
      this.hasAuskunftsperre = false;
    } else {
      this.hasAuskunftsperre = auskunftsperre === PersonStammMasterDetailEntryMeta.AuskunftsperreEnum.AUSKUNFT_SPERRE;
    }
  }

  get itemVersionId(): PersonGbVersionId {
    if (!this.item) {
      return null;
    }
    if (this.item['versionId']) {
      return this.item['versionId'];
    }
    return this.item.id;
  }

  getDefaultTemplate(): TemplateRef<any> {
    return this.typ00Template;
  }

  registerTemplates() {
    this.bindTemplates(this.typ00Template, 'PERSONGB_TYP00');
    this.bindTemplates(this.typ01Template, 'PERSONGB_TYP01');
  }

  isNotEmpty(item: DateEntryMeta): boolean {
    if (item) {
      return item.year != null || item.month != null || item.day != null;
    }
    return false;
  }
}
